import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { openOverlayOutlet } from '@epicuro-next/state/router-store';
import { Store } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-elements-product-card.component.html',
  standalone: false,
})
export class DynamicElementsProductCardComponent {
  @Input() public set product(value: Product | undefined) {
    this.productValue = value;
  }
  public get product(): Product | undefined {
    return this.productValue;
  }
  private productValue?: Product;

  @Input() public productIsMarketing = false;
  public get isLoading(): boolean {
    return this.product === undefined;
  }

  constructor(private readonly store: Store) {}

  public onClick(product: Product): void {
    const action = this.openProductOverlayOutlet(product);
    this.store.dispatch(action);
  }

  private openProductOverlayOutlet(product: {
    productId: string;
    brandId: string;
    parent?: { productId: string } | null;
  }): ReturnType<typeof openOverlayOutlet> {
    const overlayPath = [
      'cs',
      product.brandId,
      product.parent?.productId ?? product.productId,
      product.productId,
    ];

    return openOverlayOutlet({ overlayPath });
  }
}
